module.exports = __webpack_public_path__ + "img/cuowu.d326d255.png";